<template>
  <a-card :bordered="false" class="mt-20">
    <!-- 表格筛选 start -->
    <a-form
      layout="inline"
      @submit="handleSubmit"
    >
      <!-- 输入关键词查找 -->
      <a-form-item class="mr-20">
        <!-- 关键字搜索 -->
        <a-input
          v-model="queryParam.keyWord"
          placeholder="请输入关键字"
          allowClear
        >
          <!-- 选择搜索类型 -->
          <a-select
            slot="addonBefore"
            v-model="queryParam.keyWordType"
            placeholder="请选择"
            style="width:100px"
          >
            <a-select-option
              :value="item.id"
              :key="item.id"
              v-for="item in searchTypeDict"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-input>
      </a-form-item>
      <!-- 创建时间 -->
      <a-form-item>
        <a-range-picker
          :value="time"
          showTime
          format="YYYY-MM-DD"
          @change="onChangeTime"
        />
      </a-form-item>
      <a-form-item title="登记次数">
        <a-input-group compact style="width: 360px">
          <a-input
            addon-before="登记次数"
            style="width: 50%;"
            v-model="queryParam.start_sc_count"
          ></a-input>
          <a-input
            style="width: 50%;"
            addon-before="次至"
            v-model="queryParam.end_sc_count"
            addon-after="次"
          ></a-input>
        </a-input-group>
      </a-form-item>
      <a-form-item title="延保次数">
        <a-input-group compact style="width: 360px">
          <a-input
            addon-before="延保次数"
            style="width: 50%;"
            v-model="queryParam.start_mt_count"
          ></a-input>
          <a-input
            addon-before="次至"
            style="width: 50%;"
            v-model="queryParam.end_mt_count"
            addon-after="次"
          ></a-input>
        </a-input-group>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          htmlType="submit"
        >搜索</a-button>
        <a-button
          style="margin-left: 8px"
          @click="reset"
        >重置</a-button>
      </a-form-item>
    </a-form>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="mt-20">
      <a-button
        type="primary"
        class="mr-20"
        @click="handleExport"
      >导出</a-button>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      style="margin-top:40px;"
      ref="table"
      size="default"
      rowKey="uid"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <!-- <span slot="avatar" slot-scope="text, record">
        <img v-if="record.avatar" :src="record.avatar" title="用户头像" alt="用户头像" style="width:100%;float:left;"/>
        <img v-if="!record.avatar" src="../../assets/images/avatar.png" title="用户头像" alt="用户头像" style="width:100%;float:left;"/>
      </span> -->
      <!-- <span slot="openid" slot-scope="text, record">
        <span v-if="record.openid">公众号-{{ record.openid }}<br /></span>
        <span v-if="record.wxapp_openid">小程序-{{ record.wxapp_openid }}</span>
      </span> -->
      <span
        slot="action"
        slot-scope="text, record"
      >
        <template>
          <a @click="toMemberRecodeList(record.uid)">登记记录</a>
          <a-divider type="vertical" />
          <a @click="toMaintainList(record.phone)">延保记录</a>
          <a-divider type="vertical" />
          <a @click="toRepairList(record.uid)">报修记录</a>
        </template>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 查看弹出 -->
    <viewDrawer
      v-if="viewVisible"
      :visible="viewVisible"
      :id="id"
      @hide="cancelViewDrawer"
      @finish="finishViewAndEdit"
    />
  </a-card>
</template>
<script>
import { getUserPre, getUserList } from '@/api/member'
import { TcgTable } from '@/components'
import viewDrawer from './viewDrawer'
import _ from 'lodash'
import { downloadFile } from '@/utils'

const searchTypeDict = [
  {
    id: 'nickname',
    name: '微信昵称'
  },
  {
    id: 'phone',
    name: '手机号码'
  },
  {
    id: 'uid',
    name: '用户ID'
  }
]
export default {
  name: 'MemberIndex',
  components: {
    TcgTable,
    viewDrawer
  },
  data() {
    return {
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 关键字搜索类型列表
      searchTypeDict,
      // 字典
      dict: {
        statusDict: []
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        status: '',
        keyWordType: 'nickname',
        keyWord: '',
        start_time: '',
        end_time: '',
        start_sc_count: '',
        end_sc_count: '',
        start_mt_count: '',
        end_mt_count: ''
      },
      // 表头
      columns: [
        {
          title: '用户ID',
          dataIndex: 'uid',
          width: '100px'
        },
        {
          title: '注册时间',
          dataIndex: 'create_time',
          width: '100px'
        },
        {
          title: '手机号码',
          dataIndex: 'phone',
          width: '100px'
        },
        {
          title: '微信昵称',
          dataIndex: 'nickname',
          width: '100px',
          scopedSlots: { customRender: 'nickname' }
        },
        {
          title: '登记记录',
          dataIndex: 'sale_record_count',
          width: '80px'
        },
        {
          title: '延保记录',
          dataIndex: 'maintain_order_count',
          width: '80px'
        },
        {
          title: '操作',
          dataIndex: 'id',
          width: '150px',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getUserList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      }
    }
  },
  created() {
    this.handelPre()
    // 查询用户
    if (this.$route.query.uid) {
      this.queryParam.keyWord = this.$route.query.uid
      this.queryParam.keyWordType = 'uid'
      this.$nextTick(() => {
        this.$refs.table.refresh(true)
      })
    }
  },
  methods: {
    // 导出
    handleExport() {
      const href = window.location.origin + '/merchant.php/Member/outExcel'
      downloadFile(href)
    },
    handelPre() {
      getUserPre().then((res) => {
        if (_.get(res, 'code') === 200) {
          this.dict.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 重置按钮
    reset() {
      this.queryParam = {
        status: '',
        keyWordType: 'nickname',
        keyWord: '',
        start_time: '',
        end_time: '',
        start_sc_count: '',
        end_sc_count: '',
        start_mt_count: '',
        end_mt_count: ''
      }
      this.time = []
    },
    // 关闭查看按钮事件
    cancelViewDrawer() {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal(id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit() {
      this.$refs.table.refresh(true)
    },
    // 选择时间事件
    onChangeTime(dateStrings) {
      this.time = dateStrings
      if (dateStrings.length !== 0) {
        this.queryParam.start_time = dateStrings[0].format('YYYY-MM-DD')
        this.queryParam.end_time = dateStrings[1].format('YYYY-MM-DD')
      } else {
        this.queryParam.start_time = ''
        this.queryParam.end_time = ''
      }
    },
    // 提交筛选
    handleSubmit(e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 开启更多查询方式
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 跳转到登记记录
    toMemberRecodeList(uid) {
      this.$router.push({ name: 'memberRecodeList', query: { uid } })
    },
    // 跳转到延保记录
    toMaintainList(phone) {
      this.$router.push({ name: 'maintainList', query: { phone } })
    },
    // 跳转到报修记录
    toRepairList(uid) {
      this.$router.push({ name: 'repairManageIndex', query: { uid } })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
